import { render } from "./PriceLabelParamSettingButton.vue?vue&type=template&id=35687210"
import script from "./PriceLabelParamSettingButton.vue?vue&type=script&lang=ts"
export * from "./PriceLabelParamSettingButton.vue?vue&type=script&lang=ts"

import "./PriceLabelParamSettingButton.vue?vue&type=style&index=0&id=35687210&lang=less"
script.render = render

export default script